import {RichText} from 'exceljs';
import {COLUMN_CAPTIONS, ColumnTypes} from 'src/modules/attributes/constants';
import {Filters} from 'src/modules/attributes/typedefs';
import {CRITERIA_EXCEPTION_MESSAGE, EXCEL_CELL_MAX_LENGTH} from 'src/modules/downloads/cells/cells';
import {defaultCriteriaKeyFont} from 'src/modules/downloads/cells/fonts';
import {createRichTextEntry} from 'src/modules/downloads/criteria/criteria';
import {getRichTextLength} from 'src/modules/downloads/utils/get-rich-text-length';

const ALL_ATTRIBUTES_CRITERIA_MESSAGE = 'All Attributes';

const arrayToRichText = (key: string, array: string[]): RichText[] => {
    const keyCaption = COLUMN_CAPTIONS[key as ColumnTypes];
    return array.length ? createRichTextEntry(keyCaption, array.join(', ')) : [];
};

export const getCriteriaRichText = (filters: Filters) => {
    const richText = Object.entries(filters)
        .flatMap(([key, value]) => arrayToRichText(key, value));

    if (getRichTextLength(richText) >= EXCEL_CELL_MAX_LENGTH) {
        return [{text: CRITERIA_EXCEPTION_MESSAGE, font: defaultCriteriaKeyFont}];
    }

    return richText.length
        ? richText
        : [{text: ALL_ATTRIBUTES_CRITERIA_MESSAGE, font: defaultCriteriaKeyFont}];
};
